<template>
  <!-- Sign in Section start -->
  <section class="auth-page">
    <div class="animation-circle-inverse">
      <i></i>
      <i></i>
      <i></i>
    </div>
    <div class="animation-circle">
      <i></i>
      <i></i>
      <i></i>
    </div>
    <div class="download">
      <img
        src="../assets/images/other-page/down.png"
        alt="down"
        class="img-fluid icon"
      />
      <h3>Your download should begin automatically</h3>
      <h4>
        If it doesn’t start automatically,
        <a href="#" class="manual-down"
          >please click here to downlaod manually.</a
        >
      </h4>
      <router-link target="_blank" :to="{ name: 'Index' }">
        <img src="../assets/images/title-logo.png" alt="logo" class="mt-3" />
      </router-link>
    </div>
  </section>
  <!-- Sign in Section End -->
</template>
<script>
export default {
  name: "Signin",
  mounted: function () {
    document.body.classList.remove("inner-page");
  },
};
</script>
